const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function generateString(length) {
  let result = ' ';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

$('#offer-form').on('submit', function(e) {

    e.preventDefault();
  
  	var refid = $(this).find('input[type="submit"]').attr('id');
    
  	var offermobile = $(this).find('.tel-no').val();
  	var visitorId = generateString(10);
  	var creativeId = refid;
  
    $("#"+refid+'-notice').text('');
	$("#"+refid+'-notice').removeClass('request-success');
    $("#"+refid+'-notice').removeClass('request-fail');
  
	$.ajax({
    
      //url: "https://firesidedigital.online/shopify-attentive-api/index.php",
      url: "https://sdjax.com/shopify-attentive-api/index.php",
	  method: "POST",
	  contentType: "text/plain",
      data: "{\"phone\":\""+offermobile+"\"}",
      dataType: "text",
      success: function (res)
 	  {
        var returnres = JSON.parse(res);
        displayResponse(returnres,refid);
      },
      error: function (xhr, status, error)
      {
        var returnres = JSON.parse(xhr.responseText);
        displayResponse(returnres,refid);
      }
	});
  return false;
});

/* end Sign up for text. */

/* Sign up for email. */

$('#offer-form-email').on('submit', function(e) {

    e.preventDefault();
  
  	var refid = $(this).find('input[type="submit"]').attr('id');
    
  	var offeremail = $(this).find('.newsletter').val();
  	var visitorId = generateString(10);
  	var creativeId = refid;
  
    $("#"+refid+'-notice').text('');
	$("#"+refid+'-notice').removeClass('request-success');
    $("#"+refid+'-notice').removeClass('request-fail');
  
	$.ajax({
    
      url: "https://firesidedigital.co/shopify-attentive-api/index.php",
	  method: "POST",
	  contentType: "text/plain",
      data: "{\"email\":\""+offeremail+"\",\"visitorId\":\""+visitorId+"\",\"creativeId\":\""+creativeId+"\"}",
      dataType: "text",
      success: function (res)
 	  {
        var returnres = JSON.parse(res);
        displayResponse(returnres,refid);
      },
      error: function (xhr, status, error)
      {
        var returnres = JSON.parse(xhr.responseText);
        displayResponse(returnres,refid);
      }
	});
  return false;
});

/* End Sign up for email. */

function displayResponse(returnres,refid){
    if ($.trim(returnres.status) != 'false') {
          $("#"+refid+'-notice').text($.trim(returnres.message));
          $("#"+refid+'-notice').addClass('request-success');  
      }
      else {
          $("#"+refid+'-notice').text($.trim(returnres.message));
          $("#"+refid+'-notice').addClass('request-fail');
      }
}
$(".tel-no").focus(function() {
    $(this).attr('placeholder', '(###) ###-####');
}).blur(function() {
    $(this).attr('placeholder', 'Cell Phone');
});
$( ".tel-no" ).keypress(function() {
    var text_id = $(this).attr('id');
	document.getElementById(text_id).addEventListener('input', function (e) {
   		var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  		e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
	});  
});

$('#size-chart-form').on('submit', function(e) {
    e.preventDefault();
    $('center.size-chart-results').show();
    var ribsize = $('#ribsize').val();
    var cupsize = $('#cupsize').val();

    if (ribsize == 'BAND' || cupsize == 'CUP') {
        $('#final-fit-size').text('Please Select Band and Cup Size');
        $('.fit_3.two-size-content').hide();

    } else {

        if (
            ((ribsize == '28' || ribsize == '30') && (cupsize == 'A' || cupsize == 'B')) ||
            ((ribsize == '32' || ribsize == '34') && cupsize == 'A')
        ) {
            $('#final-fit-size').text('XS');

        } else if (
            (ribsize == '28' && (cupsize == 'C' || cupsize == 'D')) ||
            (ribsize == '32' && cupsize == 'B')
        ) {
            $('#final-fit-size').text('XS or Small');
            $('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '28' && cupsize == 'DD(E)') ||
            (ribsize == '30' && (cupsize == 'C' || cupsize == 'D')) ||
            (ribsize == '34' && cupsize == 'B')
        ) {
            $('#final-fit-size').text('Small');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '28' && cupsize == 'DDD(F)') ||
            ((ribsize == '30' || ribsize == '32') && cupsize == 'DD(E)') ||
            (ribsize == '32' && cupsize == 'D') ||
            ((ribsize == '32' || ribsize == '34') && cupsize == 'C') ||
            (ribsize == '36' && (cupsize == 'A' || cupsize == 'B'))
        ) {
            $('#final-fit-size').text('Small or Medium');
            $('.fit_3.two-size-content').show();

        } else if (
            ribsize == '30' && (cupsize == 'DDD(F)' || cupsize == 'G')
        ) {
            $('#final-fit-size').text('Medium');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '30' && cupsize == 'H') ||
            (ribsize == '32' && cupsize == 'DDD(F)') ||
            (ribsize == '34' && cupsize == 'D') ||
            (ribsize == '36' && cupsize == 'C')
        ) {
            $('#final-fit-size').text('Medium or Luxe');
            $('.fit_3.two-size-content').show();

        } else if (
            ribsize == '30' && cupsize == 'I'
        ) {
            $('#final-fit-size').text('Luxe');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '32' && (cupsize == 'G' || cupsize == 'H')) ||
            (ribsize == '34' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)')) ||
            (ribsize == '36' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '38' && (cupsize == 'B' || cupsize == 'C'))
        ) {
            $('#final-fit-size').text('LUXE or 1LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '32' && cupsize == 'I') ||
            (ribsize == '34' && cupsize == 'H') ||
            (ribsize == '36' && cupsize == 'DDD(F)') ||
            (ribsize == '38' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '40' && (cupsize == 'B' || cupsize == 'C')) ||
            (ribsize == '42' && cupsize == 'B')
        ) {
            $('#final-fit-size').text('1LUXE or 2LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            ribsize == '34' && cupsize == 'G'
        ) {
            $('#final-fit-size').text('1LUXE');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '34' && cupsize == 'I') ||
            (ribsize == '36' && cupsize == 'G')
        ) {
            $('#final-fit-size').text('2LUXE');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '36' && (cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '38' && cupsize == 'DDD(F)') ||
            (ribsize == '40' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '42' && cupsize == 'C')
        ) {
            $('#final-fit-size').text('2LUXE or 3LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            ribsize == '38' && cupsize == 'G'
        ) {
            $('#final-fit-size').text('3LUXE');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '38' && cupsize == 'H') ||
            (ribsize == '40' && (cupsize == 'DDD(F)' || cupsize == 'G')) ||
            (ribsize == '42' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'D')) ||
            (ribsize == '44' && (cupsize == 'C' || cupsize == 'D'))
        ) {
            $('#final-fit-size').text('3LUXE or 4LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            ribsize == '38' && cupsize == 'I'
        ) {
            $('#final-fit-size').text('4LUXE');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '40' && cupsize == 'H') ||
            (ribsize == '42' && cupsize == 'G') ||
            (ribsize == '44' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)'))
        ) {
            $('#final-fit-size').text('4LUXE/5LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '40' && cupsize == 'I') ||
            (ribsize == '42' && cupsize == 'H') ||
            (ribsize == '46' && cupsize == 'C')
        ) {
            $('#final-fit-size').text('5LUXE');
            $('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '42' && cupsize == 'I') ||
            (ribsize == '44' && (cupsize == 'G' || cupsize == 'H')) ||
            (ribsize == '46' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'D'))
        ) {
            $('#final-fit-size').text('5LUXE or 6LUXE');
            $('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '44' && cupsize == 'I') ||
            (ribsize == '46' && (cupsize == 'G' || cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '48' && (cupsize == 'C' || cupsize == 'D' || cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'G' || cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '50' && (cupsize == 'D' || cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'G' || cupsize == 'H' || cupsize == 'I'))
        ) {
            $('#final-fit-size').text('6LUXE');
            $('.fit_3.two-size-content').hide();
        }

    }
});

$('#bust-rib-size-chart-form').on('submit', function(e) {
  event.preventDefault();
  	$('center.bust-size-chart-results').show();
  	var bustsize = $('#bustsize').val();
  	var ribcagesize = $('#ribcagesize').val();

//alert("bustsize==>"+bustsize);
//alert("ribcagesize==>"+ribcagesize);
  
   if(bustsize =='Bust' || ribcagesize == 'Rib'){
    $('#bust-final-fit-size').text('Please Select Bust and Rib Cage Size');
    
  }
  else {
    if(((bustsize == '29' || bustsize == '31') && (ribcagesize == '22' || ribcagesize == '25' || ribcagesize == '26' || ribcagesize == '27')) ) {
      $('#bust-final-fit-size').text('XSmall');
    }
    else if(((bustsize == '32' || bustsize == '35') && (ribcagesize == '25' || ribcagesize == '26' || ribcagesize == '27' || ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32')) ) {
      $('#bust-final-fit-size').text('Small');
    }
    else if(((bustsize == '35' || bustsize == '38') && (ribcagesize == '26' || ribcagesize == '27' || ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5')) ) {
      $('#bust-final-fit-size').text('Medium');
    }
    else if(((bustsize == '38' || bustsize == '40') && (ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36')) ) {
      $('#bust-final-fit-size').text('Luxe');
    }
    else if(((bustsize == '40' || bustsize == '42') && (ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38')) ) {
      $('#bust-final-fit-size').text('1Luxe');
    }
    else if(((bustsize == '42' || bustsize == '44') && (ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40')) ) {
      $('#bust-final-fit-size').text('2Luxe');
    }
    else if(((bustsize == '44' || bustsize == '46') && (ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43')) ) {
      $('#bust-final-fit-size').text('3Luxe');
    }
    else if(((bustsize == '46' || bustsize == '49') && (ibcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44')) ) {
      $('#bust-final-fit-size').text('4Luxe');
    }
    else if(((bustsize == '49' || bustsize == '52') && (ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44' || ribcagesize == '47.5')) ) {
      $('#bust-final-fit-size').text('5Luxe');
    }
    else if(((bustsize == '52' || bustsize == '55') && (ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44' || ribcagesize == '47.5' || ribcagesize == '49.5')) ) {
      $('#bust-final-fit-size').text('6Luxe');
    }
    else {
      $('#bust-final-fit-size').text('No Size in This Range');
    }
  }
});

$('.accordion-common').click(function(e123) {
  	e123.preventDefault();
    var $this = $(this);
    $this.next().slideToggle(350);
     $this.next().toggleClass('accordion-tab-active');
});

var acc = document.getElementsByClassName("accordion-title");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("accordion-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
  
  $(".fitting-pages a").click(function() {
    const clink = jQuery(this).attr('href');
    jQuery('html, body').animate({
        scrollTop: $(clink).offset().top - 100
    }, 2000);
  });
// Begin tabbed content script

$(document).ready(function() {
$('#tabs li a:not(:first)').addClass('inactive');
$('.tabcontainer').hide();
$('.tabcontainer:first').show();
$('#tabs li a').click(function(){
  var t = $(this).attr('id');

  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');

    $('.tabcontainer').hide();
    $('#'+ t + 'C').fadeIn('slow');
 }
});
});
/*
$(document).ready(function() {    

$('#tabs li a:not(:first)').addClass('inactive');
$('.container').hide();
$('.container:first').show();
$('#tabs li a').click(function(){
    var t = $(this).attr('href');
    $('#tabs li a').addClass('inactive');        
    $(this).removeClass('inactive');
    $('.container').hide();
    $(t).fadeIn('slow');
    return false;
})

if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');         
    $(this).removeClass('inactive');
    $('.container').hide();
    $(t).fadeIn('slow');    
}

});
*/